import React from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Cushion,
  FlexContainer,
  LinearGradient,
  Space,
  Typography,
} from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';

const NetworkPanelHeader = ({ user }) => (
  <LinearGradient
    component="div"
    angle={90}
    stops={[
      [0, 'alabaster'],
      [100, 'white'],
    ]}
    style={{ flexShrink: 0 }}
  >
    <Cushion vertical={36} horizontal={36}>
      <FlexContainer alignItems="stretch">
        <Space right="medium">
          <Avatar image={user.avatar} includeRetina alt={user.name} size={48} />
        </Space>
        <FlexContainer flexDirection="column" justifyContent="center">
          <Typography preset="subtitle--small" color="black">
            {user.name}
          </Typography>
          <Cushion top="xxsmall">
            <Typography preset="body--small" color="dustygrey">
              <Trans i18nKey="common:logged_in_state">Signed in</Trans>
            </Typography>
          </Cushion>
        </FlexContainer>
      </FlexContainer>
    </Cushion>
  </LinearGradient>
);

NetworkPanelHeader.propTypes = {
  user: PropTypes.shape({
    avatar: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
};

export default NetworkPanelHeader;
